<div class="quick-tip m-2 rounded-lg">
    <p class="text-xs"><strong>Quick Tip</strong></p>
    <p class="text-xxs">Rules are applied automatically when entities are created or updated.</p>
</div>

<p class="text-x fs-7 mb-2 m-2 mt-4 mb-4">Available Compliance Rules for : <span class="fw-bold">{{ entity_type_name }}</span></p>
<div class="card shadow rounded-lg border table-border-color p-4 table-responsive m-2">
  <table id="rules_table" class="table table-hover">
    <thead class="custom-header">
      <tr>
        <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Rule Name</th>
        <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Description</th>
        <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Data Point</th>
        <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Frequency</th>
        <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Created At</th>
        <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Status</th>
        <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Import</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="rule in filtered_rules" :key="rule.id">
        <td class="text-xxs text-start">{{ rule.name }}</td>
        <td class="text-xxs text-start">{{ rule.description }}</td>
        <td class="text-xxs text-start">{{ rule.data_point }}</td>
        <td class="text-xxs text-start">{{ rule.frequency }}</td>
        <td class="text-xxs text-start">{{ rule.created_at }}</td>
        <td class="text-xxs text-start">
          <div class="text-start text-xxs">
            <label class="form-check-label text-xxs status-badge" :for="'status-' + rule.id">
              {{ rule.is_active ? 'Active' : 'Inactive' }}
            </label>
          </div>
        </td>
        <td class="text-start text-xxs">
          <div class="form-check form-switch d-flex align-items-center">
            <input 
              class="form-check-input" 
              type="checkbox" 
              :id="'assign-' + rule.id"
              :checked="is_rule_imported(rule.id)"
              @change="toggle_rule_import(rule)"
              :disabled="table_loading"
            >
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>